module.exports = __webpack_public_path__ + "0ec31e3650e74435cb2f5e10c663c451.svg";